<template>
  <div class="article-contentainer">
    <article-list :article="articleList"></article-list>
    <section class="loading">
      <p
        id="waterfall"
        v-if="!nomore"
      >
        <span @click="getMore()">{{ $t('tag-article.more') }}</span>
      </p>
      <div
        id="waterfall-nomore"
        v-else
      >
        <span class="line"></span>
        <p>已显示全部文章</p>
        <span class="line"></span>
      </div>
    </section>
  </div>
</template>
<script>
import * as api from "~/api/index";
import articleList from "~/components/index/article-list.vue";
export default {
  data() {
    return {
      nomore: true,
      page: 1,
      count: 30
    }
  },
  async asyncData({ app, error, req, store, $axios, route }) {
    const tag = route.params.type
    let articleResult = null,
      memberTagResult = null,
      nomore = false;
    if (tag === '会员专享') {
      let type = route.query.type || "guru_selected"  // 不存则默认获取格隆精选
      articleResult = await $axios(api.vipArticleList(type))

    } else {
      articleResult = await $axios(api.getIndexArticle({ tags: tag, page: 1, count: 30 }))
    }

    if (articleResult && articleResult.result) {
      if (tag === '会员专享') {
        nomore = articleResult && articleResult.result ? false : true
      } else {
        nomore = articleResult && articleResult.result && articleResult.result.length < articleResult.totalCount ? false : true
      }
    } else {
      nomore = true
    }
    return {
      routerTag: tag,
      articleList: articleResult && articleResult.result ? articleResult.result : [],
      nomore: nomore,
      memberTimeTemp: tag === '会员专享' && articleResult && articleResult.result ? articleResult.result[articleResult.result.length - 1].contents.timestamp : '',
    }
  },
  methods: {
    // 获取专辑文章
    async getMemberArticleList() {
      this.nomore = false
      let type = this.$route.query.type
      let articleResult = await this.$axios(api.vipArticleList(type))
      this.articleList = articleResult && articleResult.result ? articleResult.result : []
      this.memberTimeTemp = articleResult && articleResult.result && articleResult.result.length ? articleResult.result[articleResult.result.length - 1].contents.timestamp : ''
    },
    async getMore() {
      let articleResult = null;
      if (this.routerTag === '会员专享') {
        let type = this.$route.query.type // 不存则默认获取格隆精选
        articleResult = await this.$axios(api.vipArticleList(type, this.memberTimeTemp))
      } else {
        this.page++;
        articleResult = await this.$axios(api.getIndexArticle({ tags: this.routerTag, page: this.page, count: this.count }))
      }

      if (articleResult && articleResult.result) {

        this.memberTimeTemp = this.routerTag === '会员专享' ? articleResult.result[articleResult.result.length - 1].contents.timestamp : ''
        this.articleList = [...this.articleList, ...articleResult.result]
        if (this.routerTag === '会员专享') {
          this.nomore = articleResult.result ? false : true
        } else {
          this.nomore = articleResult.totalCount > this.articleList.length ? false : true
        }
      } else {
        this.nomore = true
      }

    }
  },
  beforeCreate() {
    if (this.$route.params.type === '会员专享' && !this.$route.query.type) {
      this.$router.push('/tag/会员专享?type=guru_selected')
    }
  },
  components: {
    articleList
  },
  watch: {
    $route: {
      handler() {

        if (this.$route.params.type === '会员专享')
          if (!this.$route.query.type) {
            this.$router.push('/tag/会员专享?type=guru_selected')
          }
        this.getMemberArticleList()
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.article-contentainer {
}
</style>

